(function() { module.exports = this["wp"]["keycodes"]; }());